module.exports = "./images/logo-shopvise.png";